import React from 'react'
import {motion} from 'framer-motion'
function PassWordValidator({newPassword}) {
    return (
        <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            className='m-1'
            transition={{ duration: 1 }}>
            <p className="text-[#666666] text-[16px] text-left">Password must have atleast:</p>
            <p className={`text-left font-minionpro ${newPassword.length>7?'text-[#6BB231]':'text-[#FC4523]'}`}>8+ characters</p>
            <p className={`text-left font-minionpro ${/[A-Z]/.test(newPassword) ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>
                1 uppercase</p>
            <p className={`text-left font-minionpro ${/[a-z]/g.test(newPassword) ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>
                1 lowercase</p>
            <p
                className={`text-left font-minionpro ${/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(newPassword)
                    ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>1 special character</p>
            <p className={`text-left font-minionpro ${/\d/g.test(newPassword)?'text-[#6BB231]':'text-[#FC4523]'}`}>1 number</p>
        </motion.div>
    )

}

export default PassWordValidator
